import { INoVenue } from '../models/no-venue.interface';

export const NO_VENUE: INoVenue = {
    lat: 0,
    lon: 0,
    zoom: 2,
    bearing: 0,
    pitch: 0,
}